<script>import { transformProps } from "@unpic/core";
import styleToCss from "style-object-to-css-string";
$:
  ({ style: parentStyle, ...props } = $$props);
$:
  ({
    alt,
    style: styleObj,
    src,
    width,
    height,
    loading,
    decoding,
    srcset,
    role,
    sizes,
    fetchpriority
  } = transformProps(props));
$:
  style = [styleToCss(styleObj || {}), parentStyle].filter(Boolean).join(";");
</script>

<img
  {...$$props}
  {style}
  {loading}
  {width}
  {height}
  {decoding}
  {role}
  {fetchpriority}
  alt={alt?.toString()}
  src={src?.toString()}
  srcset={srcset?.toString()}
  sizes={sizes?.toString()}
  on:load
  on:error
/>
